import React from 'react'
import { FormGroup, TextField, Typography } from '@mui/material'
import update from 'immutability-helper'
import { initRule } from '../../../lib/rule'
import { formUpdate } from '../../../lib/form'
import AccordionPreset from './AccordionPreset'

const name = 'time-race'

const initPreset = {
  name,
  timerMin: 3,
  timerSec: 0,
  pointCorrect: 1,
  pointWrong: -2
}

const Nomx = ({ accordionExpanded, onAccordionChange, rule, setRule }) => {
  const [form, setForm] = React.useState(initPreset)
  const change = formUpdate(setForm)

  React.useEffect(() => {
    setForm((rule.preset && rule.preset.name === name) ? rule.preset : initPreset)
  }, [rule.preset])

  const submit = () => {
    const newRule = update(initRule, {
      player: {
        pointCorrect: { $set: form.pointCorrect },
        pointWrong: { $set: form.pointWrong },
        batsuWrong: { $set: 0 },
        winPoint: { active: { $set: false } },
        loseBatsu: { active: { $set: false } }
      },
      other: {
        timer: {
          active: { $set: true },
          min: { $set: form.timerMin },
          sec: { $set: form.timerSec }
        }
      },
      showScore: { $set: false },
      preset: { $set: form }
    })
    setRule(newRule)
  }

  return (
    <AccordionPreset name={name} label="タイムレース" onSubmit={submit}
                     accordionExpanded={accordionExpanded === name}
                     onAccordionChange={onAccordionChange(name)}>
      <Typography variant="body2">
        制限時間内により多くのポイントを取るのが目標です.
      </Typography>
      <FormGroup row={true} className="mt-5">
        <TextField type="number" variant="standard"
                   label="分" className="timer-min"
                   inputProps={{ required: true, min: 0 }}
                   value={form.timerMin}
                   onChange={change.number(value => ({ timerMin: { $set: value } }))} />
        <TextField type="number" variant="standard"
                   label="秒" className="timer-sec"
                   inputProps={{ required: true, min: 0, max: 59 }}
                   value={form.timerSec}
                   onChange={change.number(value => ({ timerSec: { $set: value } }))} />
        <TextField type="number" variant="standard"
                   label="正解ポイント" className="point-correct ml-10"
                   inputProps={{ required: true, min: 0 }}
                   value={form.pointCorrect}
                   onChange={change.number(value => ({ pointCorrect: { $set: value } }))} />
        <TextField type="number" variant="standard"
                   label="誤答ポイント" className="point-wrong ml-10"
                   inputProps={{ required: true, max: 0 }}
                   value={form.pointWrong}
                   onChange={change.number(value => ({ pointWrong: { $set: value } }))} />
      </FormGroup>
    </AccordionPreset>
  )
}

export default Nomx
